import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ValidationService } from '../../../services/validation.service';
import { BrandMonthConversion } from '../../../models/brandMonthConversion';
import { BrandMonthConversionService } from '../../../services/brandMonthConversion.service';
import { CampaignTypeService } from '../../../services/campaignType.service';
import { CampaignType } from '../../../models/CampaignType';

@Component({
  selector: 'app-month-conversion-form',
  templateUrl: './month-conversion-form.component.html'
})

export class MonthConversionFormComponent implements OnInit { 

  public campaignTypeList: CampaignType[];

  //input/output parameters
  @Input() title;
  @Input() inputModel: BrandMonthConversion;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  public modelForm : FormGroup; 
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private brandMonthConversionService: BrandMonthConversionService,
    private notification: MatSnackBar,
    private campaignTypeService: CampaignTypeService
  ) { }

  // on component load
  ngOnInit() {

    // bind campaign types
    this.campaignTypeService.getAll().subscribe(campaignResult => {
      this.campaignTypeList = campaignResult; 
    });

    this.modelForm = this.formBuilder.group({
      id: this.inputModel.id,
      brandId: [this.inputModel.brandId, [Validators.required]],
      campaignTypeId: [this.inputModel.campaignTypeId, [Validators.required, Validators.min(1)]],
      fromMonth: [this.inputModel.fromMonth, [Validators.required, Validators.min(1)]],
      toMonth: [this.inputModel.toMonth, [Validators.required, Validators.min(1)]],
      convertMonth: [this.inputModel.convertMonth, [Validators.required, Validators.min(1)]]
    });
  }

  // handle form submit 
  onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
    if (this.modelForm.invalid) {
        return; 
    }

    let formValues = this.modelForm.value as BrandMonthConversion;

    // add
    if (formValues.id == 0) {
      this.brandMonthConversionService.add(formValues).subscribe(brandMonthConversion => {
        this.eventEmitter.emit(this.modelForm.value);
        this.activeModal.close(brandMonthConversion);
        this.showNotification(`The new month conversion ${brandMonthConversion.convertMonth} was successuly added!`, 'Okay!')
      });
      // update
    } else {
      this.brandMonthConversionService.update(formValues.id, formValues).subscribe(brandMonthConversion => {
        this.eventEmitter.emit(this.modelForm.value);
        this.activeModal.close(brandMonthConversion);
        this.showNotification(`The new month conversion ${brandMonthConversion.convertMonth} was successuly updated!`, 'Okay!')
      });
    }
  }

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
